<div class="m-nouveautesTable">
  <table class="m-nouveautesTable__table">
    <thead class="m-nouveautesTable__thead">
      <tr class="m-nouveautesTable__headerRow">
        <th class="m-nouveautesTable__th">{{ 'NOUVEAUTES.TABLE.DATE' | translate }}</th>
        <th class="m-nouveautesTable__th">{{ 'NOUVEAUTES.TABLE.SECTION_TITLE' | translate }}</th>
        <th class="m-nouveautesTable__th">{{ 'NOUVEAUTES.TABLE.STATUS' | translate }}</th>
      </tr>
    </thead>
    <tbody class="m-nouveautesTable__tbody">
      @for (item of nouveautes(); track item._id) {
        <tr
          class="m-nouveautesTable__row"
          tabindex="0"
          (click)="onRowClick(item._id)"
          (keydown.enter)="onRowClick(item._id)"
        >
          <td class="m-nouveautesTable__td m-nouveautesTable__td--date">
            {{ item.publicationDate * 1000 | date: 'longDate' : undefined : 'fr' }}
          </td>
          <td class="m-nouveautesTable__td m-nouveautesTable__td--title">
            {{ item.sections[0]?.sectionTitle || '—' }}
          </td>
          <td class="m-nouveautesTable__td">
            <span
              class="m-nouveautesTable__badge"
              [class.m-nouveautesTable__badge--active]="item.status === 'published'"
            >
              {{ item.status === 'published' ? '✓' : '✗' }}
            </span>
          </td>
        </tr>
      } @empty {
        <tr class="m-nouveautesTable__row m-nouveautesTable__row--empty">
          <td class="m-nouveautesTable__td m-nouveautesTable__td--empty" colspan="3">
            {{ 'NOUVEAUTES.TABLE.NO_RESULTS' | translate }}
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
